import React, { useState } from "react";
import LTVReportInvoiceModal from "../../../../modals/LTVReportInvoiceModal";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./../reportable.scss";
import ErrorBoundary from "../../../../error-boundary";
import ListViewFallback from "../../../../error-boundary/fallback/ListViewFallback";
import { INVOICE_DETAILS } from "../../../../../utils/constants/appConstants";
import { normalizeInvoiceIds } from "../../../../../utils/utils";

const LtvReportTable = ({ data }) => {
  const [addInvDtlsModal, setAddInvDtlsModal] = useState(false);
  const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState([]);

  const toggleAddInvDtlsModal = () => {
    setAddInvDtlsModal(!addInvDtlsModal);
  };

  const handleCellClick = (invoiceDetailsRaw) => {
    if (!invoiceDetailsRaw || !Array.isArray(invoiceDetailsRaw)) return;
    const normalized = normalizeInvoiceIds(invoiceDetailsRaw);
    setSelectedInvoiceDetails(normalized);
    setAddInvDtlsModal(true);
  };

  const matrix = Array.isArray(data) ? data : data?.data || [];
  if (matrix.length < 2) return null;

  const columnHeaders = matrix[0];
  const regionRows = matrix.slice(1);
  const rowLabels = regionRows[0].map(([label]) => label);

  return (
    <>
      <div className="col-md-12">
        <div className="table-responsive">
          <ErrorBoundary fallback={<ListViewFallback />}>
            <table className={`mt-2 mb-3 common-table`}>
              <thead>
                <tr>
                  <th />
                  {rowLabels.map((label, labelIndex) => (
                    <th key={labelIndex}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {regionRows.map((regionData, regionIdx) => (
                  <tr key={regionIdx}>
                    <td>
                      <strong>{columnHeaders[regionIdx]}</strong>
                    </td>
                    {regionData.map(([, cell], index) => {
                      const value = cell?.value;
                      const invoiceDetails = cell?.[INVOICE_DETAILS];
                      return (
                        <td key={index}>
                          {value ? (
                            <Link
                              onClick={() => handleCellClick(invoiceDetails)}
                            >
                              {value}
                            </Link>
                          ) : (
                            value
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </ErrorBoundary>
        </div>
      </div>
      {addInvDtlsModal && (
        <LTVReportInvoiceModal
          isOpen={addInvDtlsModal}
          toggle={toggleAddInvDtlsModal}
          invoiceDetails={selectedInvoiceDetails}
        />
      )}
    </>
  );
};

LtvReportTable.propTypes = {
  data: PropTypes.array
};
export default LtvReportTable;
